import React, { cloneElement } from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface ModuleCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  color: string;
  actions: string[];
  onClick: () => void;
}
export const ModuleCard = ({
  title,
  description,
  icon,
  color,
  actions,
  onClick
}: ModuleCardProps) => {
  return <div className="bg-white rounded-lg shadow overflow-hidden flex flex-col" data-id="element-559">
      <div className="p-5 flex-1" data-id="element-560">
        <div className="flex items-center mb-4" data-id="element-561">
          <div className={`p-3 rounded-lg ${color} bg-opacity-15 mr-4`} data-id="element-562">
            {cloneElement(icon as React.ReactElement, {
            className: color.replace('bg-', 'text-')
          })}
          </div>
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-563">{title}</h3>
        </div>
        <p className="text-sm text-gray-600 mb-4" data-id="element-564">{description}</p>
        <div className="flex space-x-3" data-id="element-565">
          {actions.map((action, index) => <button key={index} className={`px-3 py-1 text-xs font-medium rounded-full ${index === 0 ? `${color} text-white hover:bg-opacity-90` : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-566">
              {action}
            </button>)}
        </div>
      </div>
      <button onClick={onClick} className={`w-full py-3 px-5 text-sm font-medium text-gray-700 bg-gray-50 flex items-center justify-between border-t border-gray-100 ${color === 'bg-blue-500' ? 'hover:bg-[#E2ECFE]' : color === 'bg-green-500' ? 'hover:bg-[#DEF6E7]' : color === 'bg-orange-500' ? 'hover:bg-[#FEEADC]' : color === 'bg-purple-500' ? 'hover:bg-[#F2E6FE]' : ''}`} data-id="element-567">
        <span data-id="element-568">Zum Modul</span>
        <ChevronRightIcon size={16} data-id="element-569" />
      </button>
    </div>;
};